import React, { useEffect, useState, useRef } from "react";
import Search from "../../../Assets/Images/search.svg";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { saveAs } from "file-saver";
import ClipLoader from "react-spinners/ClipLoader";
import PaginationTab from "../../../components/PaginationTab";
import SearchStaff from "../../../components/SearchStaff";
import Cookies from "js-cookie";
import { HeaderSkeleton, PaginationSkeleton, TableSkeleton } from "./StaffTab";

const LeaveBalance = () => {
  const {
    baseUrl,
    openToast,
    staffs,
    fetchStaffs,
    fetchDepartments,
    isLoading,
    setSelectedStaff,
    setSelectedStaffIds,
    selectedStaffIds,
    selectAll,
    setSelectAll,
    loadingStaffs
  } = useGlobalContext();

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const [toggleDrop, setToggleDrop] = useState(false);

  const dropdownRef = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const staffDropDown = useRef(null);

  const handleSelectAll = () => {
    if (selectAll) {
      // If already selected, clear all selections
      setSelectedStaffIds([]);
    } else {
      // Select all staff IDs
      const allStaffIds = staffs.map((staff) => staff.staffDetails.id);
      setSelectedStaffIds(allStaffIds);
    }
    setSelectAll(!selectAll);
  };


  function handledrop() {
    setToggleDrop(!toggleDrop);
  }
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };


  useEffect(() => {
    if (staffs?.length == 0) {
      fetchStaffs();
      fetchDepartments();
    }
  }, []);



  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
    if (staffDropDown.current && !staffDropDown.current.contains(e.target)) {
      setToggleDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  let subtitle;

  // toggle switch
  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => {
    setIsOn(!isOn);
  };
  // toggle switch


  function handledrop() {
    setToggleDrop(!toggleDrop);
  }

  // when onclick update staff
  const [modalIsOpen10, setIsOpen10] = React.useState(false);
  function openModal10() {
    setIsOpen10(true);
  }
  function afterOpenModal10() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal10() {
    setIsOpen10(false);
  }
  // when onclick update staff

  // when onclick leave Policies
  const [modalIsOpen11, setIsOpen11] = React.useState(false);
  function openModal11() {
    setIsOpen11(true);
  }
  function afterOpenModal11() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal11() {
    setIsOpen11(false);
  }
  // when onclick leave Policies

  // when on click update leave policiy
  const [modalIsOpen12, setIsOpen12] = React.useState(false);
  function openModal12() {
    setIsOpen12(true);
  }
  function afterOpenModal12() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal12() {
    setIsOpen12(false);
  }
  // when on click update leave policy
  const exportToCSV = () => {
    // Check and get headers dynamically only if LeavePolicy exists and is an array
    const leavePolicyHeaders = Array.isArray(
      staffs[0]?.staffDetails?.LeavePolicy
    )
      ? staffs[0].staffDetails.LeavePolicy.map(
        (policy) => `${policy?.name} Leave Balance`
      )
      : [];

    const headers = ["Index", "Name", "Job Title", ...leavePolicyHeaders];

    const rows = staffs.map((item, index) => {
      return [
        index + 1,
        item?.name || "N/A",
        item?.staffDetails?.job_title || "N/A",
        ...(Array.isArray(item?.staffDetails?.LeavePolicy)
          ? item.staffDetails.LeavePolicy.map((policy) => policy.allowed_leaves)
          : []),
      ];
    });

    console.log("Headers:", headers);
    console.log("Rows:", rows);

    const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "LeaveBalancePolicy.csv");
  };

  const [selectedId, setSelectedId] = useState([]);
  console.log("selec", selectedId);
  const [leaveName, setLeaveName] = useState();
  const [allowLeave, setAllowLeave] = useState();
  const [carryLeave, setCarryLeave] = useState();
  const [policyType, setPolicyType] = useState();

  async function updateBalance() {
    const result = await fetch(baseUrl + "leave-policy/bulk", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
      },
      body: JSON.stringify({
        name: leaveName,
        allowed_leaves: Number(allowLeave),
        carry_forward_leaves: Number(carryLeave),
        policy_type: policyType,
        staffIds: selectedId,
      }),
    });

    const response = await result.json();

    if (result.status == 201) {
      openToast(
        response.message || "Leave Policy Created Successfully",
        "success"
      );
      closeModal12();
    } else {
      openToast(response.message || "Internal Server Error", "error");
    }
  }

  if (loadingStaffs && !staffs) {
    return (
      <div className="mt-[20px] staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }

  return (
    <div className="mt-[20px] staff-tab">
      <div className="tabs-attendance">
        <Tabs>
          <TabList className="flex lg:flex-row xl:flex-row flex-col gap-[10px] mb-[20px]">
            <Tab>
              <button>Leave Balance</button>
            </Tab>
            <Tab>
              {" "}
              <button>Leave Policy</button>
            </Tab>

            <div className="flex justify-end w-full">
              <button
                className="border-1 pt-2 pr-3 pb-2 pl-3 border rounded-md w-full md:w-[26%] text-sm second-btn"
                onClick={openModal10}
              >
                Import Leave Balances
              </button>
            </div>
          </TabList>

          <TabPanel>
            <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between lg:gap-[0px]">
              <SearchStaff dropdownRef={dropdownRef} setDropdownOpen={setDropdownOpen} toggleDropdown={toggleDropdown} isDropdownOpen={isDropdownOpen} />
            </div>

            <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
              <div className="w-full">
                <table className="w-full table-section">
                  <thead className="border-1 border">
                    <th>Name</th>
                    <th>Job Title</th>

                    {staffs?.map((items, index) => {
                      return (
                        <>
                          {items?.staffDetails?.LeavePolicy?.map((item) => (
                            <>
                              <th>{item?.name} Leave Balance</th>
                            </>
                          ))}
                        </>
                      );
                    })}
                  </thead>
                  <tbody>

                    {
                      loadingStaffs && !staffs &&
                      <tr className="h-[100px]">
                        <td
                          colSpan="11"
                          className="py-4 font-semibold text-center text-gray-600 text-xl"
                        >
                          <ClipLoader color="#27004a" size={50} />
                        </td>
                      </tr>
                    }

                    {
                      !loadingStaffs && staffs && staffs?.map((items, index) => {
                        return (
                          <tr className="border">
                            <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                              <Link
                                onClick={() => setSelectedStaff(items)}
                                to={`/leavepolicy-detail/${items?.staffDetails?.id}`}
                                className="font-medium text-[#8A25B0]"
                              >
                                {items?.name}
                              </Link>
                            </td>
                            <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                              {items?.staffDetails?.job_title}
                            </td>
                            {staffs?.map((items, index) => {
                              {
                                console.log(items?.staffDetails?.LeavePolicy);
                              }
                              return (
                                <>
                                  {items?.staffDetails?.LeavePolicy?.map(
                                    (item) => (
                                      <>
                                        <td className="border-[#dbdbdb] border-r whitespace-nowrap"> {item?.allowed_leaves} </td>
                                      </>
                                    )
                                  )}
                                </>
                              );
                            })}
                          </tr>
                        );
                      })
                    }

                    {
                      !loadingStaffs && staffs && staffs?.length === 0 &&
                      <tr>
                        <td
                          colSpan="11"
                          className="py-4 font-semibold text-center text-gray-600 text-xl"
                        >
                          No Client Found
                        </td>
                      </tr>
                    }


                  </tbody>
                </table>
              </div>
            </div>
            <PaginationTab />
          </TabPanel>

          <TabPanel>
            <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[0px]">

              <div className="flex justify-between lg:justify-start gap-[15px] w-full">
                <SearchStaff dropdownRef={dropdownRef} setDropdownOpen={setDropdownOpen} toggleDropdown={toggleDropdown} isDropdownOpen={isDropdownOpen} />
                <button
                  className={
                    "border border-1 pl-3 pr-3 rounded-md pt-2 pb-2 text-sm second-btn " +
                    (isLoading && "cursor-not-allowed opacity-50 animate-pulse")
                  }
                  disabled={isLoading}
                  onClick={openModal12}
                >
                  Update Leave Policy
                </button>
              </div>
            </div>

            <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
              <div className="w-full">
                <table className="w-full table-section">
                  <thead className="border-1 border">
                    <th>
                      <input type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />{""}
                    </th>
                    <th>Name</th>
                    {staffs?.map((items, index) => {
                      {
                        console.log(items?.staffDetails?.LeavePolicy);
                      }
                      return (
                        <>
                          {items?.staffDetails?.LeavePolicy?.map((item) => (
                            <>
                              <th>{item?.name} Leave Policy</th>
                            </>
                          ))}
                        </>
                      );
                    })}
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr className="h-[100px]">
                        <td
                          colSpan="9"
                          className="py-4 font-semibold text-center text-gray-600 text-xl"
                        >
                          <ClipLoader color="#27004a" size={50} />
                        </td>
                      </tr>
                    ) : staffs && staffs?.length > 0 ? (
                      staffs?.map((items, index) => {
                        return (
                          <tr className="border">
                            <td className="border-[#dbdbdb] border-r">
                              <input
                                type="checkbox"
                                className="border-1 border rounded-md"
                                onChange={(e) =>
                                  setSelectedId([
                                    ...selectedId,
                                    items.staffDetails.id,
                                  ])
                                }
                              />
                            </td>
                            <td>
                              <Link
                                onClick={() => setSelectedStaff(items)}
                                to={`/leavepolicy-detail/${items?.staffDetails?.id}`}
                                className="font-medium text-[#8A25B0]"
                              >
                                {items?.name}
                              </Link>
                            </td>
                            {staffs?.map((items, index) => {
                              {
                                console.log(items?.staffDetails?.LeavePolicy);
                              }
                              return (
                                <>
                                  {items?.staffDetails?.LeavePolicy?.map(
                                    (item) => (
                                      <>
                                        <td>{item?.allowed_leaves} </td>
                                      </>
                                    )
                                  )}
                                </>
                              );
                            })}
                          </tr>
                        );
                      })
                    ) : (
                      // No Data State
                      <tr className="h-[100px]">
                        <td
                          colSpan="9"
                          className="py-4 font-semibold text-center text-red-500 text-xl"
                        >
                          No staff found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <PaginationTab />
          </TabPanel>
        </Tabs>
      </div>

      {/* when onclick update staff */}

      <Modal
        isOpen={modalIsOpen10}
        onAfterOpen={afterOpenModal10}
        onRequestClose={closeModal10}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px] text-center"
        >
          Update Leave Balances for all Staff
        </h2>
        <button
          onClick={closeModal10}
          className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="pb-2">
          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[0px]">
              <h4 className="m-0 font-medium text-[10px] xl:text-[14px]">
                Step 1. Download SalaryBox Template
              </h4>
            </div>
            <div className="flex items-center">
              <button
                onClick={exportToCSV}
                className="p-1 rounded-md text-[13px] whitespace-nowrap outline-1 outline-dashed outline-offset-1"
              >
                Download Template
              </button>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[0px]">
              <h4 className="m-0 font-medium text-[10px] xl:text-[14px]">
                Step 2. Upload Leave Balances
              </h4>
            </div>
            <div className="flex items-center">
              <button className="p-1 rounded-md text-[13px] outline-1 outline-dashed outline-offset-1">
                Upload Staff List
              </button>
              {/* <input type='file' placeholder='ddjfksj'/> */}
            </div>
          </div>
        </div>
      </Modal>
      {/* when onclick update staff
       */}

      {/* when onclick leave policies
       */}

      <Modal
        isOpen={modalIsOpen12}
        onAfterOpen={afterOpenModal12}
        onRequestClose={closeModal12}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px]"
        >
          Update Leave Policy
        </h2>
        <button
          onClick={closeModal12}
          className="top-[3px] right-[5px] absolute bg-[##27004a] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="pb-2">
          <div className="flex gap-[20px] py-[15px] pl-[20px]">
            <label className="text-[14px]">Select Type</label>
            <div className="flex items-center gap-[10px] cursor-pointer">
              <input
                type="radio"
                id="fixed"
                value="MONTHLY"
                name="fixed"
                onChange={(e) => setPolicyType(e.target.value)}
                className="rounded-full"
              />
              <label for="fixed" className="text-[14px]">
                {" "}
                Monthly
              </label>
              <br />
            </div>
            <div className="flex items-center gap-[10px] cursor-pointer">
              <input
                type="radio"
                id="flexible"
                name="fixed"
                value="YEARLY"
                onChange={(e) => setPolicyType(e.target.value)}
                className="rounded-full"
              />
              <label for="flexible" className="text-[14px]">
                {" "}
                Yearly
              </label>
              <br />
            </div>
          </div>

          <div className="flex border-1 shadow pr-3 pl-3 border rounded-md w-[100%] overflow-scroll">
            <table className="mt-4 table-section">
              <thead className="border-1 border">
                <th>Leave Name</th>
                <th>
                  Allowed Leaves (Per{" "}
                  {policyType === "MONTHLY" ? "Month" : "Year"})
                </th>
                <th>
                  Carry-forward Leaves (On{" "}
                  {policyType === "MONTHLY" ? "Month" : "Year"} End)
                </th>
              </thead>
              <tbody>
                <td>
                  <input
                    type="text"
                    onChange={(e) => setLeaveName(e.target.value)}
                    className="p-2 border rounded-md focus:outline-none"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    onChange={(e) => setAllowLeave(e.target.value)}
                    className="p-2 border rounded-md focus:outline-none"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    onChange={(e) => setCarryLeave(e.target.value)}
                    className="p-2 border rounded-md focus:outline-none"
                  />
                </td>
              </tbody>
              <button
                disabled={isLoading}
                className={
                  "second-btn mb-2 " +
                  (isLoading && "cursor-not-allowed opacity-50 animate-pulse")
                }
                onClick={updateBalance}
              >
                Update Leave Balances
              </button>
            </table>
          </div>
        </div>
      </Modal>
      {/* when onclick leave policies
       */}
    </div>
  );
};

export default LeaveBalance;
